module.exports = __webpack_public_path__ + "img/cat.e99d6a98.svg";